class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.closeTimeout = null; // Para el delay

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    
    // Agregar hover para desktop con delay
    if (window.innerWidth >= 990) {
      this.mainDetailsToggle.addEventListener('mouseenter', () => {
        // Cancelar el cierre si el cursor vuelve
        if (this.closeTimeout) {
          clearTimeout(this.closeTimeout);
          this.closeTimeout = null;
        }
        this.mainDetailsToggle.setAttribute('open', '');
      });
      
      this.mainDetailsToggle.addEventListener('mouseleave', () => {
        // Esperar 300ms antes de cerrar
        this.closeTimeout = setTimeout(() => {
          this.mainDetailsToggle.removeAttribute('open');
        }, 200);
      });
      
      // Agregar hover a todos los submenús con delay
      const allSubDetails = this.querySelectorAll('details');
      allSubDetails.forEach((detail) => {
        let subCloseTimeout = null;
        
        detail.addEventListener('mouseenter', (e) => {
          e.stopPropagation();
          if (subCloseTimeout) {
            clearTimeout(subCloseTimeout);
            subCloseTimeout = null;
          }
          detail.setAttribute('open', '');
        });
        
        detail.addEventListener('mouseleave', (e) => {
          e.stopPropagation();
          subCloseTimeout = setTimeout(() => {
            detail.removeAttribute('open');
          }, 200);
        });
      });
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
